import { render, staticRenderFns } from "./chatPractice.vue?vue&type=template&id=724f10d5&scoped=true"
import script from "./chatPractice.vue?vue&type=script&lang=js"
export * from "./chatPractice.vue?vue&type=script&lang=js"
import style0 from "./chatPractice.vue?vue&type=style&index=0&id=724f10d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724f10d5",
  null
  
)

export default component.exports